import { render, staticRenderFns } from "./rec.vue?vue&type=template&id=2f26d0be&"
import script from "./rec.vue?vue&type=script&lang=js&"
export * from "./rec.vue?vue&type=script&lang=js&"
import style0 from "./rec.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports